export default "__VITE_ASSET__DG$loJrv__"